import type { AvatarColor } from '@/types';
import { CharacterPortrait } from './CharacterPortrait';

const COLORS: AvatarColor[] = [
  'amber', 'rose', 'violet', 'sky', 'emerald',
  'orange', 'teal', 'fuchsia', 'lime', 'indigo',
];

const COLOR_BG: Record<AvatarColor, string> = {
  amber: 'bg-amber-300',
  rose: 'bg-rose-300',
  violet: 'bg-violet-300',
  sky: 'bg-sky-300',
  emerald: 'bg-emerald-300',
  orange: 'bg-orange-300',
  teal: 'bg-teal-300',
  fuchsia: 'bg-fuchsia-300',
  lime: 'bg-lime-300',
  indigo: 'bg-indigo-300',
};

interface Props {
  emoji: string;
  color: AvatarColor;
  onEmojiChange: (emoji: string) => void;
  onColorChange: (color: AvatarColor) => void;
}

export function AvatarPicker({ emoji, color, onEmojiChange, onColorChange }: Props) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4">
        <CharacterPortrait emoji={emoji} color={color} size="lg" />
        <div className="space-y-2">
          <label className="text-xs font-medium text-muted-foreground block">Emoji</label>
          <input
            type="text"
            value={emoji}
            onChange={(e) => {
              const chars = [...e.target.value];
              if (chars.length > 0) onEmojiChange(chars[chars.length - 1]);
            }}
            className="w-16 text-center text-2xl bg-muted rounded-lg px-2 py-1 border border-border outline-none focus:ring-2 focus:ring-ring"
            placeholder="🙂"
          />
        </div>
      </div>
      <div>
        <label className="text-xs font-medium text-muted-foreground block mb-2">Farbe</label>
        <div className="flex flex-wrap gap-2">
          {COLORS.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => onColorChange(c)}
              className={`w-7 h-7 rounded-full ${COLOR_BG[c]} transition-transform ${
                c === color ? 'ring-2 ring-offset-2 ring-ring scale-110' : 'hover:scale-105'
              }`}
              aria-label={c}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
